import { render, staticRenderFns } from "./WarehouseManager.vue?vue&type=template&id=73a0b6b0&"
import script from "./WarehouseManager.vue?vue&type=script&lang=ts&"
export * from "./WarehouseManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports